import { render, staticRenderFns } from "./InstantAppUpdate.vue?vue&type=template&id=b234242a"
import script from "./InstantAppUpdate.vue?vue&type=script&lang=js"
export * from "./InstantAppUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports